export const parseDefaultFormHash = (hash: string): number => {
  if (hash === '') {
    return 0;
  }

  if (hash.startsWith('#')) {
    hash = hash.substring(1);
  }

  const urlHashNum = parseInt(hash);

  return isNaN(urlHashNum) || urlHashNum === 0 ? 0 : urlHashNum - 1;
};

export const parseFormHashWithInitialStep = (hash: string): number => {
  if (hash === '') {
    return 0;
  }

  if (hash.startsWith('#')) {
    hash = hash.substring(1);
  }

  return parseInt(hash) || 0;
};
